import React from 'react'
import { NavLink } from 'react-router-dom'
import Button from '../components/Button'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import TitleSection from '../sections/TitleSection'

const StartTestPage = () => {
  return (
    <div className='__page-container'>
        <Navbar />      
        <div className='__container'>
          <TitleSection title="Test din virksomhed" body='Testen er en hurtig og nem måde at evaluere din virksomheds modstandsdygtighed på, og den tager cirka 10 minutter at gennemføre. Det anbefales at flere personer i virksomheden tager testen, for at skabe et fyldestgørende og retvisende billede af jeres modstandsdygtighed.  ' />
          
          <NavLink to="/test" className="__ms-lg-10">
            <Button buttonText='Start test' />
          </NavLink>
            
        </div>
        <Footer />
    </div>
  )
}

export default StartTestPage